import BootCheckbox from "components/common/custom/forms/BootCheckbox";
import TextInput from "components/common/custom/forms/BootTextField/TextField";
import MultiSelect from "components/common/MultiSelect";
import WizardModal from "components/wizard/WizardModal";
import {
  GetAllClaimPreAuthAllList,
  GetAllPreauthorizationType,
} from "features/preauthorization/config/preauthorizationApi";
import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { ViewSettings } from "../config/FieldSettingsApi";

const AddFieldSettingsForm = ({
  control,
  watch,
  setValue,
  errors,
  isSubmitted,
}) => {
  const dispatch = useDispatch();
  const [filteredSubTypes, setFilteredSubTypes] = useState([]);
  const [showTypeAlert, setShowTypeAlert] = useState(false);
  const [menuStates, setMenuStates] = useState({
    type: false,
    subType: false,
  });
  const { settingData } = useSelector((state) => state.settings);

  const {
    visitReasons,
    processPriority,
    serviceTypeList,
    preauthorizationType,
    preauthorizationSubType,
    investgationList,
  } = useSelector((state) => state.preauthorization);

  // Handle menu toggle for type dropdown
  const handleTypeMenuToggle = (isOpen) => {
    setMenuStates((prev) => ({ ...prev, type: isOpen }));
  };

  // Handle menu toggle for sub-type dropdown
  const handleSubTypeMenuToggle = (isOpen) => {
    if (isOpen && !watch("preauthorization_type")) {
      setShowTypeAlert(true);
      return setMenuStates((prev) => ({ ...prev, subType: false }));
    }
    setMenuStates((prev) => ({ ...prev, subType: isOpen }));
  };

  // Fetch initial data
  useEffect(() => {
    if (
      visitReasons?.length === 0 ||
      processPriority?.length === 0 ||
      serviceTypeList?.length === 0
    ) {
      dispatch(GetAllClaimPreAuthAllList());
    }
    if (
      preauthorizationSubType?.length === 0 ||
      preauthorizationType?.length === 0
    ) {
      dispatch(GetAllPreauthorizationType());
    }
    if (investgationList?.length === 0) {
      dispatch(GetAllClaimPreAuthAllList());
    }
  }, [
    visitReasons,
    processPriority,
    investgationList,
    serviceTypeList,
    preauthorizationSubType,
    preauthorizationType,
  ]);

  // Filter and auto-select sub-types when type changes
  useEffect(() => {
    const selectedType = watch("preauthorization_type");
    const currentSubType = watch("preauthorization_sub_type");

    if (!selectedType) {
      setFilteredSubTypes([]);
      setValue("preauthorization_sub_type", null);
      return;
    }

    // Filter sub-types based on selected type
    let updatedSubTypes = [];
    const typeName = selectedType?.claim_types_name;

    if (typeName === "Institutional") {
      updatedSubTypes = preauthorizationSubType.filter(
        (sub) => sub.claimsub_types_name === "InPatient"
      );
    } else if (typeName === "Professional") {
      updatedSubTypes = preauthorizationSubType.filter((sub) =>
        ["OutPatient", "Emergency"].includes(sub.claimsub_types_name)
      );
    } else {
      updatedSubTypes = preauthorizationSubType.filter(
        (sub) => sub.claimsub_types_name === "OutPatient"
      );
    }

    setFilteredSubTypes(updatedSubTypes);

    if (updatedSubTypes.length === 1) {
      setValue("preauthorization_sub_type", {
        claimsub_types_id: updatedSubTypes[0].claimsub_types_id,
        claimsub_types_name: updatedSubTypes[0].claimsub_types_name,
      });
    }

    if (
      !currentSubType ||
      !updatedSubTypes.some(
        (sub) => sub?.claimsub_types_id === currentSubType.claimsub_types_id
      )
    ) {
      setValue("preauthorization_sub_type", null);
    }
  }, [watch("preauthorization_type"), preauthorizationSubType]);

  useEffect(() => {
    dispatch(ViewSettings());
  }, []);

  useEffect(() => {
    const data = settingData?.[0];
    setValue("server_url", data?.server_url || "");
    setValue("nphies_url", data?.nphies_url || "");
    setValue("boarding_type", data?.boarding_type || "");
    setValue("group_vat", data?.group_vat == 1 ? true : false || false);
    setValue(
      "attachemnt",
      data?.fieldsetting_txt?.supinfo_attch == 1 ? true : false || false
    );
    setValue(
      "save_preauth",
      data?.fieldsetting_txt?.sve_preauth == 1 ? true : false || false
    );
    setValue(
      "visit_reason",
      visitReasons?.find(
        (item) =>
          item?.visitreas_code === data?.fieldsetting_txt?.sup_info_vreas
      )
    );
    setValue(
      "preauthorization_type",
      preauthorizationType?.find(
        (item) => item?.claim_types_id === data?.fieldsetting_txt?.claim_type
      )
    );
    setValue(
      "preauthorization_sub_type",
      preauthorizationSubType?.find(
        (item) =>
          item?.claimsub_types_id ===
          data?.fieldsetting_txt?.claimsub_types_name
      )
    );
    setValue(
      "priority_type",
      processPriority?.find(
        (item) => item?.prcspri_code === data?.fieldsetting_txt?.process_prior
      )
    );
    setValue(
      "investgation_result",
      investgationList?.find(
        (item) =>
          item?.investreslttype_code === data?.fieldsetting_txt?.sup_info_invres
      )
    );
    setValue(
      "service_type",
      serviceTypeList?.find(
        (item) => item?.servtype_code === data?.fieldsetting_txt?.prd_type
      )
    );
    setValue("treatment_plan", data?.fieldsetting_txt?.sup_info_trtpln);
    setValue(
      "patient_history",
      data?.fieldsetting_txt?.sup_info_pathistry || ""
    );
    setValue("patient_examination", data?.fieldsetting_txt?.sup_info_phyexmn);
    setValue(
      "history_present_illness",
      data?.fieldsetting_txt?.sup_info_histrypreill
    );
  }, [setValue, settingData]);

  return (
    <Row>
      {/* Server URL */}
      {/* <Col xs={12} sm={6} md={3} xl={2}>
        <TextInput
          name="server_url"
          label="Server Url"
          placeholder="Server Url"
          control={control}
          size="sm"
          errors={errors}
          value="http://212.227.240.195"
          disabled={true}
        />
      </Col>

      <Col xs={12} sm={6} md={3} xl={2}>
        <TextInput
          name="nphies_url"
          label="Nphies Url"
          placeholder="Nphies Url"
          control={control}
          size="sm"
          errors={errors}
          value="http://176.105.150.83/$process-message"
          disabled={true}
        />
      </Col>

      <Col xs={12} sm={6} md={3} xl={2}>
        <TextInput
          name="boarding_type"
          label="Boarding Type"
          placeholder="Boarding Type"
          control={control}
          size="sm"
          errors={errors}
          defaultValue="test"
          disabled={true}
        />
      </Col>
      <Col
        xs={12}
        sm={6}
        md={3}
        xl={2}
        className="d-flex justify-content-center"
      >
        <BootCheckbox
          name="group_vat"
          label="Group VAT"
          defaultValue={true}
          disabled={true}
          control={control}
          className="ml-3"
        />
      </Col> */}

      {/* Visit Reason */}
      <Col xs={12} sm={6} md={3} xl={2}>
        <Form.Group controlId="visit_reason">
          <label className="form-label">Visit Reason</label>
          <Controller
            name="visit_reason"
            control={control}
            rules={{ required: false }}
            render={({ field }) => (
              <MultiSelect
                {...field}
                menuPlacement="auto"
                closeMenuOnSelect={false}
                isMulti={false}
                size="sm"
                isClearable={true}
                options={visitReasons?.map((visit) => ({
                  value: visit.visitreas_code,
                  label: visit.visitreas_name,
                }))}
                placeholder="Choose..."
                value={
                  field.value
                    ? {
                        value: field.value.visitreas_code,
                        label: field.value.visitreas_name,
                      }
                    : null
                }
                onChange={(selected) => {
                  setValue(
                    "visit_reason",
                    selected
                      ? {
                          visitreas_name: selected?.label,
                          visitreas_code: selected?.value,
                        }
                      : null
                  );
                }}
              />
            )}
          />
        </Form.Group>
      </Col>

      {/* Preauthorization Type */}
      <Col xs={12} sm={6} md={3} xl={2}>
        <Form.Group controlId="preauthorization_type">
          <label className="form-label">Preauth Type</label>
          <Controller
            name="preauthorization_type"
            control={control}
            rules={{ required: false }}
            render={({ field }) => (
              <MultiSelect
                {...field}
                options={preauthorizationType?.map((item) => ({
                  value: item.claim_types_id,
                  label: item.claim_types_name,
                }))}
                placeholder="Choose ..."
                isClearable={true}
                onChange={(selected) => {
                  setValue(
                    "preauthorization_type",
                    selected
                      ? {
                          claim_types_id: selected.value,
                          claim_types_name: selected.label,
                        }
                      : null
                  );
                }}
                value={
                  field.value
                    ? {
                        value: field.value.claim_types_id,
                        label: field.value.claim_types_name,
                      }
                    : null
                }
              />
            )}
          />
          {errors.preauthorization_type && (
            <span className="text-danger small">
              {errors.preauthorization_type.message}
            </span>
          )}
        </Form.Group>
      </Col>

      <Col xs={12} sm={6} md={3} xl={2}>
        <Form.Group controlId="preauthorization_sub_type">
          <label className="form-label">Preauth Sub Type</label>
          <Controller
            name="preauthorization_sub_type"
            control={control}
            rules={{ required: false }} // ✅ Explicitly optional
            render={({ field }) => (
              <MultiSelect
                {...field}
                options={filteredSubTypes?.map((item) => ({
                  value: item?.claimsub_types_id,
                  label: item?.claimsub_types_name,
                }))}
                placeholder="Choose ..."
                isDisabled={!watch("preauthorization_type")}
                isClearable={true}
                onMenuOpen={() => handleSubTypeMenuToggle(true)}
                onMenuClose={() => handleSubTypeMenuToggle(false)}
                onChange={(selected) => {
                  const selectedValue = selected
                    ? {
                        claimsub_types_id: selected.value,
                        claimsub_types_name: selected.label,
                      }
                    : null;
                  setValue("preauthorization_sub_type", selectedValue, {
                    shouldValidate: false, // ✅ prevent revalidation
                    shouldDirty: true,
                  });
                }}
                value={
                  field.value
                    ? {
                        value: field.value.claimsub_types_id,
                        label: field.value.claimsub_types_name,
                      }
                    : null
                }
              />
            )}
          />
          {errors?.preauthorization_sub_type && (
            <div className="text-danger small mt-1">
              {errors?.preauthorization_sub_type?.message}
            </div>
          )}
        </Form.Group>
      </Col>

      {/* Process Priority */}
      <Col xs={12} sm={6} md={3} xl={2}>
        <Form.Group controlId="priority_type">
          <label className="form-label">Process Priority</label>
          <Controller
            name="priority_type"
            control={control}
            rules={{ required: false }}
            render={({ field }) => (
              <MultiSelect
                {...field}
                options={processPriority?.map((priority) => ({
                  value: priority.prcspri_code,
                  label: priority.prcspri_name,
                }))}
                placeholder="Choose..."
                isClearable={true}
                onChange={(selected) => {
                  setValue(
                    "priority_type",
                    selected
                      ? {
                          prcspri_code: selected.value,
                          prcspri_name: selected.label,
                        }
                      : null
                  );
                }}
                value={
                  field.value
                    ? {
                        value: field.value.prcspri_code,
                        label: field.value.prcspri_name,
                      }
                    : null
                }
              />
            )}
          />
          {errors.priority_type && (
            <span className="text-danger small">
              {errors.priority_type.message}
            </span>
          )}
        </Form.Group>
      </Col>
      {/* Attachment Mandatory */}
      <Col xs={12} sm={6} md={3} xl={2}>
        <BootCheckbox
          name="attachemnt"
          label="Attachment Mandatory"
          required={false}
          control={control}
          className="ml-3"
        />
      </Col>

      {/* Save in Preauthorization */}
      <Col xs={12} sm={6} md={3} xl={2}>
        <BootCheckbox
          name="save_preauth"
          label="Save in Preauthorization"
          required={false}
          control={control}
          className="ml-3"
        />
      </Col>

      <Col xs={12} sm={6} md={3} xl={2}>
        <TextInput
          name="treatment_plan"
          control={control}
          label="Treatment Plan"
          required={false}
          rules={{ required: false }}
          size="sm"
          multiline={true}
          rows={5}
          placeholder="Treatment Plan"
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <TextInput
          name="patient_history"
          control={control}
          label="Patient History"
          required={false}
          rules={{ required: false }}
          size="sm"
          multiline={true}
          rows={5}
          placeholder="Treatment Plan"
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <TextInput
          name="patient_examination"
          control={control}
          label="Patient Examination"
          required={false}
          rules={{ required: false }}
          size="sm"
          multiline={true}
          rows={5}
          placeholder="Patient Examination"
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <TextInput
          name="history_present_illness"
          label="History Of Present Illness"
          control={control}
          required={false}
          rules={{ required: false }}
          size="sm"
          multiline={true}
          rows={5}
          placeholder="History Of Present Illness"
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <label className="form-label mb-2">Investigation Result</label>
        <Controller
          name="investgation_result"
          control={control}
          rules={{ required: false }}
          render={({ field }) => (
            <MultiSelect
              {...field}
              menuPlacement="auto"
              closeMenuOnSelect
              options={investgationList?.map((item) => ({
                value: item.investreslttype_code,
                label: item.investreslttype_name,
              }))}
              value={
                field.value
                  ? {
                      value: field.value.investreslttype_code,
                      label: field.value.investreslttype_name,
                    }
                  : null
              }
              onChange={(selected) => {
                setValue(
                  "investgation_result",
                  selected
                    ? {
                        investreslttype_code: selected.value,
                        investreslttype_name: selected.label,
                      }
                    : null
                );
              }}
              isClearable
              formatOptionLabel={({ label }) => <div>{label}</div>}
              getOptionValue={(option) => option.value}
              placeholder="Choose ..."
            />
          )}
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <label className="form-label">Service Type</label>
        <Controller
          name="service_type"
          control={control}
          rules={{ required: false }}
          render={({ field }) => (
            <MultiSelect
              {...field}
              menuPlacement="auto"
              closeMenuOnSelect={false}
              isMulti={false}
              options={serviceTypeList?.map((item) => ({
                value: item.servtype_code,
                label: item.servtype_name,
              }))}
              value={
                field.value
                  ? {
                      value: field.value.servtype_code,
                      label: field.value.servtype_name,
                    }
                  : null
              }
              onChange={(selected) => {
                setValue(
                  "service_type",
                  selected
                    ? {
                        servtype_code: selected.value,
                        servtype_name: selected.label,
                      }
                    : null
                );
              }}
              formatOptionLabel={({ label }) => <div>{label}</div>}
              getOptionValue={(option) => option.value}
              placeholder="Choose ..."
            />
          )}
        />
      </Col>

      {/* Type Selection Alert */}
      <WizardModal
        modal={showTypeAlert}
        setModal={() => setShowTypeAlert(false)}
        title="Type Not Selected"
        description="Please select Preauthorization Type first before choosing Sub Type."
      />
    </Row>
  );
};

export default AddFieldSettingsForm;
